import {fabric} from "fabric";

export const eventsMix = {
  data() {
    return {
      buffer: null,
      pageY: null,
      pageYText: '',
      stepAngle: 5,
      currentPointPolyline: 0,
      currentPaintStand: 0,
      canvasState: [],
      currentStateIndex: -1,
      undoStatus: false,
      redoStatus: false,
      undoFinishedStatus: 1,
      redoFinishedStatus: 1,
      downStand: 0,
      currentMode: 'default',
      modes: {
        default: 'default',
        pan: 'pan',
        drawing: 'drawing',
        polyline: 'polyline'
      },
      cloneActiveObjects: [],
      currentKey: null,
      canvasMousePress: false,
    }
  }, methods: {
    getCopyBufer() {
      // console.log('вставка',this.buffer)
      if (this.buffer) {
        this.copyElementByLayout(this.buffer)
      }
    },
    setCopyBufer() {
      let activeObj = this.canvas.getActiveObjects().length > 0 ? this.canvas.getActiveObjects()[0] : null
      // console.log('activeObj',activeObj)
      if (activeObj) {
        this.buffer = activeObj
      }
    },
    setCurrentMode(item) {
      // console.log(item)
      this.currentMode = item

      if (item == 'default') {
        this.currentPolyLine = {}
        this.currentPointPolyline = 0
        this.canvas.hoverCursor = 'default';
        this.canvas.setCursor('default')
        this.setOpacityElementCanvas(1)
        this.canvas.selection = true
        this.setSelectionElementCanvas(true)
        this.canvas.renderAll()
      }

      if (item == 'hand') {
        this.canvas.setCursor('grab')
        this.canvas.hoverCursor = 'grab';
        this.setOpacityElementCanvas(1)
        this.canvas.selection = false
        this.setSelectionElementCanvas(false)
        this.canvas.renderAll()
      }
      if (this.currentMode === 'standPaint') {
        this.setOpacityElementCanvas(0.5)
        let id = this.$uuid.v1();
      }

      if (this.currentMode === 'polyline') {
        this.setOpacityElementCanvas(0.5)
        let id = this.$uuid.v1();
        const element = this.currentPolyLine = new fabric.Path('', {
          index: this.currentLayoutCroupIndex,
          id: id,
          stroke: 'grey',
          strokeWidth: 1,
          fill: 'white',
          top: 50,
          left: 200
        });
        element.set('event', {type: 'none', value: 0})
        this.canvas.setCursor('copy')
        this.canvas.hoverCursor = 'copy';
        this.canvas.add(this.currentPolyLine);
        this.setSelectionElementCanvas(false)
        this.canvas.selection = false
        this.canvas.renderAll()
        this.setLayoutSet(element)
      }
      // if (this.currentMode === this.modes.pan) {
      //   this.setSelectionElementCanvas(false)
      //   this.canvas.selection = false
      //   this.canvas.renderAll()
      // }

    },
    // ---------------------------------------------
    //press key
    lockHolst() {
      this.canvas.forEachObject(function (o, index, arr) {
        if (index === arr.length - 1) {
          // console.log(index)
          console.log(arr.length)
          o.hasBorders = o.hasControls = false;
        }
      });
    },
    keydown(e) {
      console.log(e.code);


      if (this.currentMode !== 'input' && this.currentMode !== 'textChange' && this.currentMode !== 'standPaint') {

        if (e.code === 'ShiftLeft') {
          this.currentKey = 'ShiftLeft'
        }

        if (e.code === 'ControlLeft') {
          this.currentKey = 'ControlLeft'
        }

        if (e.code === 'KeyQ') {
          if (this.currentKey === 'ControlLeft') {
            this.saveCanvasNullJSONByServer()
          }
        }


        // if (e.code === 'KeyZ') {
        //   if (this.currentKey === 'ControlLeft') {
        //     this.canvas.loadFromJSON(this.canvasState[this.currentStateIndex -1])
        //     this.lockHolst()
        //     console.log('Undo <-- ')
        //   }
        // }
        // if (e.code === 'KeyX') {
        //   if (this.currentKey === 'ControlLeft') {
        //     this.canvas.loadFromJSON(this.canvasState[this.currentStateIndex+1])
        //     this.setSelectionElementCanvas(false)
        //    this.lockHolst()
        //   }
        // }

        if (e.code === 'KeyS') {
          if (this.currentKey === 'ControlLeft') {
            e.preventDefault()
            this.saveCanvasJSONByServer()
          }
        }


        if (e.code === 'Space' && this.currentMode !== 'textChange') {
          if (this.currentMode !== 'hand') {
            this.setCurrentMode('hand')
          }
        }
        if (e.code === 'KeyV') {
          if (this.currentKey === 'ShiftLeft') {
            e.preventDefault()
            this.setCurrentMode('default')
          }
          if (this.currentKey === 'ControlLeft') {
            e.preventDefault()
            this.getCopyBufer()
          }
        }
        if (e.code === 'KeyC') {
          if (this.currentKey === 'ControlLeft') {
            e.preventDefault()
            this.setCopyBufer()
          }
        }

        if (e.code === 'KeyT') {
          if (this.currentKey === 'ShiftLeft') {
            e.preventDefault()
            this.saveCanvasNullJSONByServer()
          }
        }

        if (e.code === 'KeyH') {
          if (this.currentKey === 'ShiftLeft') {
            e.preventDefault()
            this.setCurrentMode('hand')
          }
        }
        if (e.code === 'ArrowUp') {
          e.preventDefault()
          this.canvas.getActiveObjects().map((element) => {
            element.set('top', element.top - 1)
          })
          this.canvas.renderAll()
        }
        if (e.code === 'ArrowDown') {
          e.preventDefault()
          this.canvas.getActiveObjects().map((element) => {
            element.set('top', element.top + 1)
          })
          this.canvas.renderAll()
        }
        if (e.code === 'ArrowRight') {
          e.preventDefault()
          this.canvas.getActiveObjects().map((element) => {
            element.set('left', element.left + 1)
          })
          this.canvas.renderAll()
        }
        if (e.code === 'ArrowLeft') {
          e.preventDefault()
          this.canvas.getActiveObjects().map((element) => {
            element.set('left', element.left - 1)
          })
          this.canvas.renderAll()
        }
        // if (e.code === 'KeyP') {
        //   e.preventDefault()
        //   this.currentMode = this.modes.drawing
        //   this.canvas.setCursor('default')
        //   this.canvas.renderAll()
        // }
        if (e.code === 'Delete' && this.currentMode !== 'textChange') {
          e.preventDefault()
          this.deleteElementCanvas()
        }
      }

    },
    keyup(e) {
      if (e.code === 'ControlLeft') {
        this.currentKey = null
      }
      if (this.currentMode !== 'input') {
        if (e.code === 'Space' && this.currentMode !== 'textChange') {
          e.preventDefault()
          this.setCurrentMode('default')
        }
      }
      if (e.code === 'ShiftLeft') {
        this.currentKey = null
      }
      // this.setSelectionElementCanvas(true)
      // this.canvas.isDrawingMode = false
      // this.canvas.setCursor('default')
      // this.canvas.renderAll()

    },


    // ------------------------------------------------
    // mouse event from canvas
    // ------------------------------------------------
    canvasMouseOver() {
      this.MouseInCanvas = true
      // console.log('canvasMouseOver')
    },
    canvasObjectChange() {
      // console.log('canvasObjectChange')
    },
    canvasMouseOut() {
      // console.log('canvasMouseOut')
    },
    canvasTextEntered() {
      this.setCurrentMode('textChange')
    },
    canvasTextExited(e) {
      // console.log('canvasTextExited',e.target.text)
      let arr = this.layoutsGroup[this.currentLayoutCroupIndex].objects.map((el) => {
        if (el[4] === e.target.id) el[8] = e.target.text
        return el
      })

      this.layoutsGroup[this.currentLayoutCroupIndex].objects = arr

      this.setCurrentMode('default')

    },
    canvasMouseDown(e) {
      this.canvasMousePress = true


      if (this.currentMode === 'standPaint' && this.downStand === 0) {
        let id = this.$uuid.v1();
        this.downStand = 1
        let index = this.layoutsGroup.findIndex((el, i) => {
          return el.slug == 'stand'
        })
        let group = this.layoutsGroup[index]
        let element = this.currentPaintStand = new fabric.Rect({
          isStand: true,
          id: id,
          strokeWidth: 1,
          stroke: '#9A99A2FF',
          fill: '#7B7A84FF',
          top: e.absolutePointer.y,
          left: e.absolutePointer.x,
          width: 1,
          height: 1,
          noScaleCache: false,
          strokeUniform: true,
          index
        });
        element.set('event', {type: 'stand', value: this.currentStandPaintOptions.title})
        setS(element, group, index)
        function setS(element, group, index) {
          let title = ['textbox'].includes(element.type) ? element.text : element.type
          group.objects.unshift([element.type, true, false, false, element.id, element.fill, 1, index, title, 'stand', element.event.value])
        }
      }

      if (this.currentMode === 'hand') {
        this.canvas.setCursor('grabbing')
      }

      if (this.currentMode === this.modes.polyline) {
        this.currentPointPolyline = this.currentPointPolyline + 1
        let id = this.$uuid.v1();
        this.currentObjId = id;
        this.currentPolyLine.path[this.currentPolyLine.path.length] = ['L', e.absolutePointer.x, e.absolutePointer.y];
        this.currentPolyLine.setCoords()
        let dims = this.currentPolyLine._calcDimensions()
        this.currentPolyLine.set({
          id: this.currentPolyLine.id,
          fill: '#9A99A2',
          stroke: '#9A99A2',
          strokeWidth: 2,
          width: dims.width,
          height: dims.height,
          left: dims.left,
          top: dims.top,
          pathOffset: {
            x: dims.width / 2 + dims.left,
            y: dims.height / 2 + dims.top
          },
          dirty: true
        })
        this.canvas.renderAll()
      }
    },
    canvasMouseUp() {
      this.downStand = 0
      this.canvasMousePress = false
      if (this.currentMode === 'standPaint') {
        this.canvas.add(this.currentPaintStand)
        console.log(this.currentStandPaintOptions);
        this.canvas.renderAll()
        this.currentMode = 'default'
        let  index = this.layoutsGroup.findIndex((el, i) => {
          return el.slug == 'stand'
        })
        let group = this.layoutsGroup[index]
        let id = this.$uuid.v1(), element
        let obj = {
          standId:this.currentStandPaintOptions.id,
          isStandTitle: true,
          noScaleCache: false,
          strokeUniform: true,
          id,
          fontFamily: "Inter",
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          textAlign: 'left',
          index,
          fill: 'white',
          stroke: 0,
          strokeWidth: 1,
          underline: false,
          top:this.currentPaintStand.top + 5,
          left: this.currentPaintStand.left + 5,
          text: this.currentStandPaintOptions.title,
          event: {type: 'stand', value: this.currentStandPaintOptions.title}
        };
        element = new fabric.Textbox("Текст", obj);
        this.canvas.add(element)
        setS(element, group, index)


        function setS(element, group, index) {
          let title = ['textbox'].includes(element.type) ? element.text : element.type
          group.objects.unshift([element.type, true, false, false, element.id, element.fill, 1, index, title, 'stand', element.event.value])
        }


      }

      // console.log('canvasMouseUp', this.canvas.getActiveObject())
      // this.canvas.setActiveObject(this.canvas.getActiveObject()).renderAll()
      // console.log('canvasMouseUpFromMove', this.canvas.getActiveObjects())

    },
    canvasObjectModified() {
      let jsonData, canvasAsJson;
      jsonData = this.canvas.toObject(['id'])
      canvasAsJson = JSON.stringify(jsonData);
      this.canvasState.push(canvasAsJson)
      this.currentStateIndex = this.canvasState.length - 1

      // console.log('-----------------------------------')
      // console.log(this.canvasState)
      // console.log(this.currentStateIndex)
      // console.log('что-то поменялось /добавилось')
      // console.log('-----------------------------------')


    },
    canvasMouseMove(event) {
      // console.log(event)
      if (this.pageY) {
        if (event.e.pageY > this.pageY) {
          this.pageYText = 'вниз'
        } else if (event.e.pageY < this.pageY) {
          this.pageYText = 'вверх'
        } else {
          this.pageYText = 'горизонтально'
        }
      }
      this.pageY = event.e.pageY;


      this.cloneActiveObjects = this.canvas.getActiveObjects()
      if (this.canvasMousePress && this.currentMode === 'hand') {
        this.canvas.selection = false
        this.canvas.setCursor('grabbing')
        const mEvent = event.e
        const delta = new fabric.Point(mEvent.movementX, mEvent.movementY)
        this.canvas.relativePan(delta)

      }

      if (this.canvasMousePress && this.currentMode === 'standPaint') {
        const mEvent = event.e
        this.currentPaintStand.width = this.currentPaintStand.width + mEvent.movementX
        this.currentPaintStand.height = this.currentPaintStand.height + mEvent.movementY
        this.canvas.renderAll()
      }


      if (this.canvasMousePress && this.currentMode === this.modes.drawing) {
        this.canvas.isDrawingMode = true
        this.canvas.renderAll()
      }
      if (this.currentMode === 'polyline') {
        if (this.currentPolyLine.path.length > 0 && this.currentKey == 'ShiftLeft') {
          if (this.pageYText === 'горизонтально') {
            this.currentPolyLine.path[this.currentPointPolyline] = ['L', event.absolutePointer.x, this.currentPolyLine.path[this.currentPointPolyline - 1][2]]
          }
          if (this.pageYText === 'вниз' || this.pageYText === 'вверх') {
            this.currentPolyLine.path[this.currentPointPolyline] = ['L', this.currentPolyLine.path[this.currentPointPolyline - 1][1], event.absolutePointer.y]
          }
          this.currentPolyLine.setCoords()
          let dims = this.currentPolyLine._calcDimensions()
          this.currentPolyLine.set({
            id: this.currentPolyLine.id,
            fill: '#9A99A2',
            stroke: '#9A99A2',
            strokeWidth: 2,
            width: dims.width,
            height: dims.height,
            left: dims.left,
            top: dims.top,
            pathOffset: {
              x: dims.width / 2 + dims.left,
              y: dims.height / 2 + dims.top
            },

            dirty: true
          })
          this.canvas.renderAll()
        } else {
          this.currentPolyLine.path[this.currentPointPolyline] = ['L', event.absolutePointer.x, event.absolutePointer.y]
          this.currentPolyLine.setCoords()
          let dims = this.currentPolyLine._calcDimensions()
          this.currentPolyLine.set({
            id: this.currentPolyLine.id,
            fill: '#9A99A2',
            stroke: '#9A99A2',
            strokeWidth: 2,
            width: dims.width,
            height: dims.height,
            left: dims.left,
            top: dims.top,
            pathOffset: {
              x: dims.width / 2 + dims.left,
              y: dims.height / 2 + dims.top
            },
            dirty: true
          })
          this.canvas.renderAll()
        }
      }
    },
    wheel(e) {
      if (this.currentKey == 'ControlLeft') {
        let delta = e.deltaY;
        let zoom = this.canvas.getZoom();
        zoom *= 0.999 ** delta;
        if (zoom > 20) zoom = 20;
        if (zoom < 0.1) zoom = 0.1;
        this.canvas.zoomToPoint({x: e.offsetX, y: e.offsetY}, zoom);
        e.preventDefault();
        e.stopPropagation();
      }
    }
  },
  created: function () {
    window.addEventListener('keydown', this.keydown)
    window.addEventListener('keyup', this.keyup)
  },
  destroyed: function () {
    window.removeEventListener('keydown', this.keydown)
    window.removeEventListener('keyup', this.keyup)
  },
  mounted() {
    this.canvas.on('object:change', this.canvasObjectChange)
    this.canvas.on('object:modified', this.canvasObjectModified)
    this.canvas.on('object:added', this.canvasObjectModified)
    this.canvas.on('mouse:over', this.canvasMouseOver)
    this.canvas.on('mouse:up', this.canvasMouseUp)
    this.canvas.on('mouse:down', this.canvasMouseDown)
    this.canvas.on('mouse:out', this.canvasMouseOut)
    this.canvas.on('mouse:move', this.canvasMouseMove)
    this.canvas.on('text:editing:entered', this.canvasTextEntered);
    this.canvas.on('text:editing:exited', this.canvasTextExited);
    this.canvas.on('object:rotating', function (options) {
      options.target.snapAngle = 5
    });


  }
}
